import {
  Button,
  Grid,
  Paper,
  Tooltip,
  useMediaQuery,
  Theme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import parse from 'html-react-parser';
import Avatar from '@mui/material/Avatar';
import ReplyIcon from "@mui/icons-material/Reply";
import { LikeIcon, LikesIcon } from "component/commonComponents/Icon";
import { StyledAvatarBlock, StyledComments } from "./comments.style";
import EditComment from './editComment/editComment';
import HlxButton from '../../commonComponents/button/button';
import UptimeGeneralDialog from '../../dialogComponents/generalDialog/generalDialog';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import CommentInput from "./commentInput/commentInput";
import OrderDetailsComponents from "component/MarketPlace/OrderRequestDetail";
import { AttachFile } from "@mui/icons-material";
import AttachmentPopover from "./attachmentPopover/attachmentPopover";
import { Attachment, CommentValue } from "./comments.model";
import { handleKeyPress, stringAvatar } from "utils/functions";
import { attachmentValidator, maxFileSize } from "./utils";
import GeneralDialog from "../../dialogComponents/generalDialog/generalDialog";
import CommentAction from "./commentAction/commentAction";
import { COMMENT_INPUT_HEIGHT } from "./constants";
import { useHyperlinkStyle } from "component/layoutComponents/CustomLayout/CustomLayoutContext";

const avatarBlockProps = {
  size: 42,
  spacing: 16,
};
const avatarItemWidth = avatarBlockProps.size + avatarBlockProps.spacing;

const attachmentConfig = {
  acceptFiles: {
    'image/jpeg': [],
    'image/png': [],
    'text/plain': ['.txt'],
    'application/pdf': [],
  },
  maxSize: 20,
  maxFiles: 3,
  disabled: false,
};

const Comment = (props: any) => {
  const {
    children,
    comment,
    className,
    onDeleteComment,
    onDownloadAttachment,
    avatarUser,
    currentUserId,
    submitEditComment,
    hideReplyButton,
    locale,
    enableLikeComment,
    enableReplyComment,
    warningConfig,
    localeWarningDialog,
    enableEditComment,
    enableDeleteComment,
    loading
  } = props;
  const [inputVal, setInputVal] = useState("");
  const [likeComment, setLikeComment] = useState(!!comment.liked);
  const [hasEditComment, setHasEditComment] = useState(false);
  const [onSubmitComment, setOnSubmitComment] = useState(false);
  const [eventKeyPress, setEventKeyPress] = useState();
  const [onKeyPressComment, setOnKeyPressComment] = useState(false);
  const [isOpenWarning, setIsOpenWarning] = useState(false);
  const [isEditComment, setIsEditComment] = useState(false);
  const [valueEditComment, setValueEditComment] = useState<any>({});
  const [attachments, setAttachments] = useState<File[]>([]);
  const [attachmentAnchor, setAttachmentAnchor] = useState<HTMLButtonElement | null>(null);

  const isSmUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));

  const showWarning = warningConfig?.enabled && JSON.parse(localStorage.getItem(warningConfig?.key) || 'true');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (event.target.value) {
      if (event.target.value === null || event.target.value === ' ') return;
      setInputVal(event.target.value);
    } else setInputVal("");
  };
  const showHideReply = (uid: string) => {
    setInputVal("");
    props.showHideReply(uid);
  };
  const submitComment = (commentVal: CommentValue, uid: string) => {
    const { content } = commentVal;
    if(content.trim() !== ''){
      setInputVal("");
      setAttachments([]);
      props.submitComment(commentVal, uid);
    }
  };
  const handleOnKeyPress = (e: any, commentVal: CommentValue, uid: string = "") => {
    const { content } = commentVal;
    if (e.key === "Enter" && !showWarning) {
      e.preventDefault();
      if(content.trim() !== ''){
        submitComment(commentVal, uid);
      }
    } else if (e.key === "Enter" && showWarning && !isOpenWarning && !!content) {
      e.preventDefault();
      setIsOpenWarning(true);
      setEventKeyPress(e);
      setOnKeyPressComment(true);
    } else {
      if(content.trim() !== '' && !!onKeyPressComment){
        submitComment(commentVal, uid);
        setOnKeyPressComment(false);
      } else if(e.key === "Enter" && !content){
        e.preventDefault();
      }
    }
  };
  const handleChangeLike = (likeComment: boolean, comment: any) => {
    setLikeComment(!likeComment);
    props.handleChangeLike(!likeComment, comment);
  };

  const onEditComment = () => {
    setHasEditComment(true);
  };
  const onSubmitEditComment = (commentVal: CommentValue, uid: string) => {
    const { content } = commentVal;
    if(!showWarning) {
      submitEditComment(commentVal, uid);
      setHasEditComment(false);
    } else if (showWarning && !isEditComment) {
      setValueEditComment({ commentVal: content, uid});
      setIsOpenWarning(true);
      setIsEditComment(true);
    } else {
      if(!!isEditComment) {
        submitEditComment(commentVal, uid);
        setHasEditComment(false);
        setIsEditComment(false);
      }
    }
  };

  useEffect(() => {
    const files = comment?.attachments.map((attachment: Attachment) => {
      return new File([], attachment.file_name, { type: attachment.type });
    });
    setAttachments(files);
  }, [comment?.attachments]);

  const confirmWarningDialog = (
    <>
      <HlxButton
        label={localeWarningDialog?.ok || warningConfig?.editWarning?.labelButton}
        onClick={() => {
          if(!!onSubmitComment) {
            submitComment({ content: inputVal, attachments }, comment.uid);
            setOnSubmitComment(false);
          } else if (!!onKeyPressComment) {
            handleOnKeyPress(eventKeyPress, { content: inputVal, attachments }, comment.uid);
          } else if (!!isEditComment) {
            const commentValue =  { content: valueEditComment?.commentVal, attachments };
            onSubmitEditComment(commentValue, valueEditComment?.uid);
          }
          setIsOpenWarning(false);
          localStorage.setItem(warningConfig?.key, 'false');
          }
        }
      />
    </>
  );

  return (
    <>
    <div className={`comment ${className}`}>
      <Grid container wrap="nowrap" className="comment-inner">
        <Grid item>
          <StyledAvatarBlock {...avatarBlockProps}>
            {avatarUser?.user === comment?.user?.uid ?
              (!!avatarUser?.avatar ?
                <Avatar
                  src={avatarUser.avatar}
                  alt="avatar user login"
                  className="avatar-userlogin"
                  slotProps={{
                    img: {
                      title: avatarUser?.avatar_name,
                    }
                  }}
                />
                :
                <Avatar
                  {...stringAvatar(avatarUser?.avatar_name, avatarBlockProps.size)} 
                />
              )
              :
              (!!comment?.user?.initials ?
                <Avatar
                  {...stringAvatar(comment?.user?.initials, avatarBlockProps.size)} 
                />
                :
                <Avatar 
                  {...stringAvatar(comment?.user?.name, avatarBlockProps.size)} 
                />
              )
            }
          </StyledAvatarBlock>
        </Grid>
        <Grid item xs zeroMinWidth>
          <div className="cmt-content">
            <div>
            <h5 tabIndex={0} className="heading5 cmt-author-name">{comment?.user?.name}</h5>
            {!hasEditComment && (
              <div className="comment-action">
                {currentUserId === comment?.user?.uid && (
                  <CommentAction
                    enableEditComment={enableEditComment}
                    enableDeleteComment={enableDeleteComment}
                    onEditComment={onEditComment}
                    onDeleteComment={() => onDeleteComment(comment.uid)}
                    locale={locale}
                  />
                )}

                {comment.attachments.length > 0 && (
                  <>
                    <Button
                      tabIndex={0}
                      className="buttonLink attachment"
                      onClick={(e) => setAttachmentAnchor(e.currentTarget)}
                      onKeyDown={(e) => handleKeyPress(e, 'Enter', () => onEditComment)}
                    >
                      <AttachFile sx={{ width: 20, transform: 'rotate(45deg)' }} />
                    </Button>
                    <AttachmentPopover
                      open={!!attachmentAnchor}
                      anchorEl={attachmentAnchor}
                      onClose={() => setAttachmentAnchor(null)}
                      attachments={comment.attachments}
                      onDownloadAttachment={onDownloadAttachment}
                      locale={locale}
                    />
                  </>
                )}
              </div>
            )}
            <div className="comment-date">
              <p tabIndex={0} className="captionRegular cmt-author-time">
                {comment?.createdDate}
              </p>
              {!hasEditComment &&
                !!comment?.updatedDate &&
                comment?.createdDate !== comment?.updatedDate && (
                  <Tooltip
                    title={`${locale?.txtEdited} ${comment?.updatedDate}`}
                    arrow
                  >
                    <p tabIndex={0} className="captionRegular cmt-author-time edited-comment">
                      {locale?.txtEdited}
                    </p>
                  </Tooltip>
                )}
            </div>
            </div>
            {!!hasEditComment ? (
              <EditComment
                comment={comment}
                attachments={attachments}
                onAttachmentChange={setAttachments}
                handleCancelEdit={() => setHasEditComment(false)}
                submitEditComment={onSubmitEditComment}
                locale={locale}
              />
            ) : (
              <div tabIndex={0} className="cmt-content-detail bodyRegular" id="txt-comment-content">
                {parse(comment?.comments)}
              </div>
            )}
          </div>
          <Grid container display='flex' alignItems="center" className="cmt-buttons">
            <Grid item xs>
            {enableLikeComment &&
                <Button
                  tabIndex={0}
                  className={`buttonLink ${!!likeComment ? "like-comment" : ""}`}
                  onClick={() => handleChangeLike(likeComment, comment)}
                  onKeyDown={(e) => handleKeyPress(e, 'Enter', () => handleChangeLike(likeComment, comment))}
                >
                  {isSmUp && <LikeIcon role="img" aria-label="Like comment" />}
                  <span>{locale?.txtLike}</span>
                </Button>
              }
              {(enableReplyComment && !hideReplyButton) &&
                <Button
                  className="buttonLink buttonReply"
                  onClick={() => showHideReply(comment?.uid)}
                  onKeyDown={(e) => handleKeyPress(e, 'Enter', () => showHideReply(comment?.uid))}
                >
                  {isSmUp && <ReplyIcon />}
                  <span>{locale?.txtReply}</span>
                </Button>
              }
            </Grid>
            <Grid item>
              {enableLikeComment && <div tabIndex={0} className="num-likes">
                <span className="captionRegular">
                  {comment.likeCount} {comment.likeCount > 1 ? locale?.txtLikes : locale?.txtLike}
                </span>
                <LikesIcon role="img" aria-label="3 Likes" />
              </div>
              }
            </Grid>
          </Grid>
          {comment.reactQuill && (
            <div className="cmt-box">
              <Paper component="form" className="cmt-form">
                <CommentInput
                  isReplyComment={comment.reactQuill}
                  key={comment.uid}
                  value={inputVal}
                  placeholder={locale?.placeholderInput}
                  onChange={handleChange}
                  onKeyPress={(e) => handleOnKeyPress(e, { content: inputVal, attachments }, comment.uid)}
                  onSubmit={(value) => {
                    !showWarning && submitComment(value, comment.uid) ||
                    (showWarning && !isOpenWarning && !!value.content)
                    && setIsOpenWarning(true);
                    setOnSubmitComment(true);
                  }}
                  loading={loading}
                />
              </Paper>
            </div>
          )}
        </Grid>
      </Grid>
      {children.length > 0 && <div className="comment-nested">{children}</div>}
    </div>

    <UptimeGeneralDialog
      title={warningConfig?.editWarning?.title || localeWarningDialog?.warning}
      content={warningConfig?.editWarning?.content || localeWarningDialog?.msgITARFedRamp}
      isOpen={isOpenWarning}
      buttonSubmit={confirmWarningDialog}
      deviders={false}
      headerBackgroundDefault={false}
      hideButtonCancel={true}
      hideCloseIcon={true}
      commonStyles={{ width: '480px' }}
      handleClose={()=>{}}
      headerDefault={true}
      disableBackdropClick={false}
    />
    </>
  );
};

const OriginalComment = (props: any) => {
  const {
    enableLikeComment,
    enableReplyComment,
    enableEditComment,
    enableDeleteComment,
    children,
    comment,
    submitComment,
    showHideReply,
    hideReplyButton,
    className,
    handleChangeLike,
    avatarUser,
    currentUserId,
    onDeleteComment,
    onDownloadAttachment,
    submitEditComment,
    locale = {},
    warningConfig,
    localeWarningDialog,
    loading
  } = props;

  return (
    <Comment
      enableLikeComment={enableLikeComment}
      enableReplyComment={enableReplyComment}
      enableEditComment={enableEditComment}
      enableDeleteComment={enableDeleteComment}
      comment={comment}
      submitComment={submitComment}
      showHideReply={showHideReply}
      hideReplyButton={hideReplyButton}
      className={className}
      handleChangeLike={handleChangeLike}
      avatarUser={avatarUser}
      currentUserId={currentUserId}
      onDeleteComment={onDeleteComment}
      onDownloadAttachment={onDownloadAttachment}
      submitEditComment={submitEditComment}
      locale={locale}
      warningConfig={warningConfig}
      localeWarningDialog={localeWarningDialog}
      loading={loading}
    >
      {children}
    </Comment>
  );
};

function CommentNested(props: any) {
  const {
    enableLikeComment,
    enableReplyComment,
    comment,
    submitComment,
    showHideReply,
    commentlevel,
    handleChangeLike,
    avatarUser,
    currentUserId,
    onDeleteComment,
    onDownloadAttachment,
    submitEditComment,
    maxCommentLevel,
    maxIndentation,
    locale = {},
    warningConfig,
    localeWarningDialog,
    enableEditComment,
    enableDeleteComment
  } = props;

  const nestedComments = (comment.children || []).map((comment: any) => {
    return (
      <CommentNested
        key={comment.uid}
        comment={comment}
        enableLikeComment={enableLikeComment}
        enableReplyComment={enableReplyComment}
        enableEditComment={enableEditComment}
        enableDeleteComment={enableDeleteComment}
        submitComment={submitComment}
        showHideReply={showHideReply}
        commentlevel={commentlevel + 1}
        handleChangeLike={handleChangeLike}
        avatarUser={avatarUser}
        currentUserId={currentUserId}
        onDeleteComment={onDeleteComment}
        onDownloadAttachment={onDownloadAttachment}
        submitEditComment={submitEditComment}
        maxCommentLevel={maxCommentLevel}
        maxIndentation={maxIndentation}
        locale={locale}
        warningConfig={warningConfig}
        localeWarningDialog={localeWarningDialog}
      />
    );
  });

  return (
    <OriginalComment
      key={comment.uid}
      enableLikeComment={enableLikeComment}
      enableReplyComment={enableReplyComment}
      enableEditComment={enableEditComment}
      enableDeleteComment={enableDeleteComment}
      comment={comment}
      submitComment={submitComment}
      showHideReply={showHideReply}
      hideReplyButton={commentlevel >= maxCommentLevel}
      className={
        commentlevel >= maxIndentation
          ? "comment-level-no-indentation"
          : ""
      }
      handleChangeLike={handleChangeLike}
      avatarUser={avatarUser}
      currentUserId={currentUserId}
      onDeleteComment={onDeleteComment}
      onDownloadAttachment={onDownloadAttachment}
      submitEditComment={submitEditComment}
      locale={locale}
      warningConfig={warningConfig}
      localeWarningDialog={localeWarningDialog}
    >
      {nestedComments}
    </OriginalComment>
  );
};

export interface ICommentsProps {
  enableComment: boolean;
  enableReplyComment: boolean;
  enableLikeComment: boolean;
  enableEditComment: boolean;
  enableDeleteComment: boolean;
  commentsData?: any[];
  currentPage?: number;
  lastComment?: any;
  totalCountPages?: number;
  avatarUser?: any;
  currentUserId?: string;
  submitComment?: (commentVal: any, uid: string) => void;
  onDeleteComment?: (uid: string) => void;
  onDownloadAttachment?: (attachment: Attachment) => void;
  submitEditComment?: (commentVal: CommentValue, uid: string) => void;
  handleChangeLike?: (val1: any, val2: any) => void;
  handleChangePage?: () => void;
  maxCommentLevel?: number;
  maxIndentation?: number;
  locale?: any;
  warningConfig: {
    name: string,
    key: string,
    enabled: boolean,
    editWarning: {
      title: string,
      content:string,
      labelButton: string
    }
  };
  localeWarningDialog: {
    warning: string,
    msgITARFedRamp: string,
    ok: string,
  };
  loading?: boolean;
}

const Comments = (props: ICommentsProps) => {
  const {
    enableComment,
    enableReplyComment,
    enableLikeComment,
    commentsData,
    totalCountPages,
    currentPage,
    lastComment,
    avatarUser,
    currentUserId,
    onDeleteComment,
    onDownloadAttachment,
    submitEditComment,
    maxCommentLevel,
    maxIndentation,
    locale = {},
    warningConfig,
    localeWarningDialog,
    enableEditComment,
    enableDeleteComment,
    loading
  } = props;
  const [commentDataState, setCommentDataState] = useState<any[]>([]);
  const [inputVal, setInputVal] = useState("");
  const [onSubmitComment, setOnSubmitComment] = useState(false);
  const [eventKeyPress, setEventKeyPress] = useState();
  const [onKeyPressComment, setOnKeyPressComment] = useState(false);
  const [isOpenWarning, setIsOpenWarning] = useState(false);
  const [attachments, setAttachments] = useState<File[]>([]);
  const [error, setError] = useState('');
  const [isOpenAttachment, setIsOpenAttachment] = useState<boolean>(false);

  const showWarning = warningConfig?.enabled && JSON.parse(localStorage.getItem(warningConfig?.key) || 'true');

  const isSmDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const { hyperlinkStyle } = useHyperlinkStyle();

  useEffect(() => {
    setCommentDataState(commentsData || []);
  }, [commentsData]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value) {
      if (event.target.value === null || event.target.value === ' ') return;
      setInputVal(event.target.value);
    } else setInputVal("");
  };

  function submitComment(commentVal: CommentValue, uid: string = "") {
    if(commentVal.content.trim() !== '') {
      setInputVal("");
      setAttachments([]);
      props.submitComment?.(commentVal, uid);
    };
  }

  const handleOnKeyPress = (e: any, commentVal: CommentValue, uid: string = "") => {
    const { content } = commentVal;
    if (e.key === "Enter" && !showWarning) {
      e.preventDefault();
      if(content.trim() !== '') {
        submitComment(commentVal, uid);
      }
    } else if (e.key === "Enter" && showWarning && !isOpenWarning && !!content) {
        e.preventDefault();
        setIsOpenWarning(true);
        setEventKeyPress(e);
        setOnKeyPressComment(true);
    } else {
      if(content.trim() !== '' && !!onKeyPressComment){
        submitComment(commentVal, uid);
        setOnKeyPressComment(false);
      } else if(e.key === "Enter" && !content){
        e.preventDefault();
      }
    }
  };

  const showHideReply = (uid: string, isShow: boolean = true) => {
    const newCommentDate = showHideReplyChild(commentDataState, uid, isShow);
    setCommentDataState(newCommentDate);
  };

  const showHideReplyChild = (commentDataState: any[], uid: string, isShow: boolean = true) => {
    const newCommentDate = commentDataState.map((item) => {
      if (item.children && item.children.length > 0) {
        item.children = showHideReplyChild(item.children, uid, isShow);
      }
      item.uid === uid
        ? (item.reactQuill = isShow && !item.reactQuill)
        : (item.reactQuill = false);
      return item;
    });
    return newCommentDate;
  };

  const handleChangeLike = (val1: any, val2: any) => {
    props.handleChangeLike?.(val1, val2);
  };

  const handleSetFiles = (files: File[]) => {
    setAttachments((prevState) => [...prevState, ...files].slice(0, attachmentConfig.maxFiles));
    setError("");
  };

  const confirmWarningDialog = (
    <>
      <HlxButton
        label={localeWarningDialog?.ok || warningConfig?.editWarning?.labelButton}
        onClick={() => {
          const commentValue =  { content: inputVal, attachments };
          if(!!onSubmitComment) {
            submitComment(commentValue, "");
            setOnSubmitComment(false);
          } else if (!!onKeyPressComment) {
            handleOnKeyPress(eventKeyPress, commentValue, "");
          }
          setIsOpenWarning(false);
          localStorage.setItem(warningConfig?.key, 'false');
          }
        }
      />
    </>
  );

  return (
    <>
      <StyledComments isMobile={isSmDown}>
        <div className="comments-wrap">
          {enableComment &&
            <>
              <h4 tabIndex={0} className="heading4">{locale?.heading}</h4>
              <Grid container direction="row" alignItems="flex-start" flexWrap="nowrap">
                <Grid item mt={`${(COMMENT_INPUT_HEIGHT - avatarBlockProps.size) / 2}px`}>
                  <StyledAvatarBlock {...avatarBlockProps}>
                    {!!avatarUser?.avatar ?
                      <Avatar
                        src={avatarUser.avatar}
                        alt="avatar user login"
                        className="avatar-userlogin"
                        slotProps={{
                          img: {
                            title: avatarUser?.avatar_name,
                          }
                        }}
                      />
                      :
                      <Avatar
                        slotProps={{
                          img: {
                            title: avatarUser?.avatar_name,
                          }
                        }}
                        {...stringAvatar(avatarUser?.avatar_name, avatarBlockProps.size)}
                      />
                    }
                  </StyledAvatarBlock>
                </Grid>
                  <Grid item xs width={`calc(100% - ${avatarItemWidth}px)`}>
                    <Paper component="form" className="cmt-form">
                      <CommentInput
                        value={inputVal}
                        attachments={attachments}
                        placeholder={locale?.placeholderInput}
                        onChange={handleChange}
                        onAttachmentChange={setAttachments}
                        onKeyPress={(e) => handleOnKeyPress(e, { content: inputVal, attachments }, "")}
                        onSubmit={(value) => submitComment(value, "")}
                        setIsOpenAttachment={setIsOpenAttachment}
                        isOpenAttachment={isOpenAttachment}
                        locale={locale}
                        loading={loading}
                      />
                      <OrderDetailsComponents.Attachment
                        files={attachments as any}
                        config={attachmentConfig}
                        preview={false}
                        hidden={!isOpenAttachment}
                        onSetFiles={handleSetFiles}
                        onDelete={() => {}}
                        locale={locale}
                        attachmentOptions={{
                          onDropRejected(fileRejections) {
                            const defaultError = "The types of files are not allowed.";
                            const errorMessage =
                              fileRejections?.[0]?.errors?.[1]?.code === 'file-too-large'
                                ? `${locale?.uploadAttachment?.errMsg[fileRejections?.[0]?.errors?.[1]?.code]} ${maxFileSize}MB.` ||
                                  fileRejections?.[0]?.errors?.[1]?.message
                                : locale?.uploadAttachment?.errMsg[fileRejections?.[0]?.errors?.[1]?.code] ||
                                  fileRejections?.[0]?.errors?.[1]?.message ||
                                  locale?.uploadAttachment?.errMsg?.default ||
                                  defaultError;
                            setError(errorMessage);
                          },
                          validator: attachmentValidator
                        }}
                      />
                  </Paper>
                </Grid>
              </Grid>
            </>}
          {((commentsData || []).length || 0) > 0 && (
            <div className="cmt-status">
              <p tabIndex={0} className="bodyRegular">
                <span className="bodyBold">{locale?.comments}</span> ({locale?.latestComment}{" "}
                {lastComment?.createdDate}{" "}
                {locale?.by} {lastComment?.user?.name})
              </p>
            </div>
          )}
          <div className="cmt-body">
            {commentsData &&
              commentsData.length > 0 &&
              commentsData.map((comment) => {
                return (
                  <CommentNested
                    commentlevel={1}
                    enableReplyComment={enableReplyComment}
                    enableLikeComment={enableLikeComment}
                    enableEditComment={enableEditComment}
                    enableDeleteComment={enableDeleteComment}
                    key={comment.uid}
                    comment={comment}
                    submitComment={submitComment}
                    showHideReply={showHideReply}
                    handleChangeLike={handleChangeLike}
                    avatarUser={avatarUser}
                    currentUserId={currentUserId}
                    onDeleteComment={onDeleteComment}
                    onDownloadAttachment={onDownloadAttachment}
                    submitEditComment={submitEditComment}
                    maxCommentLevel={maxCommentLevel}
                    maxIndentation={maxIndentation}
                    locale={locale}
                    warningConfig={warningConfig}
                    localeWarningDialog={localeWarningDialog}
                  />
                );
              })}
          </div>
          {(commentsData || []).length > 0 &&
            Number(totalCountPages) > Number(currentPage) * 5 &&
            Number(totalCountPages) > 5 && (
              <div className="cmt-show">
                <Button
                  variant="text"
                  disableRipple={true}
                  endIcon={<KeyboardDoubleArrowDownIcon/>}
                  startIcon={<KeyboardDoubleArrowDownIcon/>}
                  onClick={props.handleChangePage}
                  onKeyDown={(e) => handleKeyPress(e, 'Enter', props.handleChangePage)}
                  sx={{ ...hyperlinkStyle }}
                >
                  {locale?.showMore}
                </Button>
              </div>
            )}
        </div>
      </StyledComments>
      <UptimeGeneralDialog
        title={warningConfig?.editWarning?.title || localeWarningDialog?.warning}
        content={warningConfig?.editWarning?.content || localeWarningDialog?.msgITARFedRamp}
        isOpen={isOpenWarning}
        buttonSubmit={confirmWarningDialog}
        deviders={false}
        headerBackgroundDefault={false}
        hideButtonCancel={true}
        hideCloseIcon={true}
        commonStyles={{ width: '480px' }}
        handleClose={()=>{}}
        headerDefault={true}
        disableBackdropClick={false}
      />
      {!!error && (
        <GeneralDialog
          title={locale?.uploadAttachment?.errMsg?.error || 'Error'}
          content={error}
          isOpen={!!error}
          buttonSubmit={<HlxButton label={locale?.uploadAttachment?.errMsg?.ok || 'Ok'} onClick={() => setError('')} />}
          deviders={false}
          headerBackgroundDefault={false}
          hideButtonCancel={true}
          hideCloseIcon={true}
          commonStyles={{ width: '480px' }}
          handleClose={() => setError('')}
        />
      )}
    </>
  );
};

export default Comments;
